module.exports = __webpack_public_path__ + "static/media/02.958ae473.mp3";